var $7940365cce7a5f46$exports = {};
const $7940365cce7a5f46$var$navEL = document.querySelector(".navbar");
window.addEventListener("scroll", ()=>{
    if (window.scrollY >= 56) $7940365cce7a5f46$var$navEL.classList.add("navbar-scrolled");
    else if (window.scrollY < 56) $7940365cce7a5f46$var$navEL.classList.remove("navbar-scrolled");
});
var $7940365cce7a5f46$var$$galleryContainer = $(".gallery").isotope({
    itemSelector: ".item",
    layoutMode: "fitRows"
});
$(".portfolio-filters  .button").on("click", function() {
    $(".portfolio-filters  .button").removeClass("active");
    $(this).addClass("active");
    var value = $(this).attr("data-filter");
    $7940365cce7a5f46$var$$galleryContainer.isotope({
        filter: value
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const currentLocation = window.location.href;
    const navLinks = document.querySelectorAll(".navbar-nav .nav-link");
    navLinks.forEach(function(link) {
        if (link.href === currentLocation) link.classList.add("active");
    });
});
// JavaScript
function $7940365cce7a5f46$var$countTo(target, element) {
    var current = 0;
    var step = Math.ceil(target / 150); // Adjust the speed of counting by changing the divisor
    var timer = setInterval(function() {
        current += step;
        if (current >= target) {
            clearInterval(timer);
            current = target;
        }
        element.textContent = current;
    }, 20); // Adjust the interval for smoother counting
}
function $7940365cce7a5f46$var$startCounting(entries, observer) {
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            entry.target.classList.add("show");
            var target = parseInt(entry.target.querySelector(".count").textContent);
            $7940365cce7a5f46$var$countTo(target, entry.target.querySelector(".count"));
            observer.unobserve(entry.target);
        }
    });
}
const $7940365cce7a5f46$var$statsSection = document.querySelector("#stats");
const $7940365cce7a5f46$var$statsObserver = new IntersectionObserver($7940365cce7a5f46$var$startCounting, {
    threshold: 0.5
});
const $7940365cce7a5f46$var$statsElements = document.querySelectorAll(".stats-item");
$7940365cce7a5f46$var$statsElements.forEach((element)=>$7940365cce7a5f46$var$statsObserver.observe(element));
function $7940365cce7a5f46$var$aosInit() {
    AOS.init({
        duration: 600,
        easing: "ease-in-out",
        once: true,
        mirror: false
    });
}
window.addEventListener("load", $7940365cce7a5f46$var$aosInit);
const $7940365cce7a5f46$var$cloneEl = document.querySelector(".logos-slide").cloneNode(true);
const $7940365cce7a5f46$var$logos = document.querySelector(".logos").appendChild($7940365cce7a5f46$var$cloneEl);


//# sourceMappingURL=index.50f776fa.js.map
